import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import orb4Actions, {
    EORB4Actions,
    EORB4Constants,
    TORB4Actions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TORB4BackendRecord } from '../@types';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const orb4HistoryMiddleware: Middleware<{}, IStore> =
    ({ dispatch, getState }) =>
    (next) =>
    (action: TORB4Actions | IAuthActions) => {
        switch (action.type) {
            case EORB4Actions.HISTORY_LOAD: {
                next(action);
                const job = jobActions(EORB4Constants.FEATURE, action.type);
                const { providedFilters: filters } = action.payload;
                dispatch(orb4Actions.document.setFilter(filters));
                dispatch(
                    apiActions.apiRequest<{ logs: { docs: TORB4BackendRecord[] } }>({
                        feature: action.type,
                        method: 'GET',
                        url: EORB4Constants.API,
                        queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.ORB2,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined
							},
							sortOrder: filters?.sortOrder ?? undefined,
                        },
                        preExecute() {
                            dispatch(job.active({}));
                        },
                        postExecute: {
                            onSuccess({ data }) {
                                const orb4Records = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.ORB2
								);
                                dispatch(
                                    orb4Actions.document.historySet(
										commonUtils.arrayToObject(orb4Records)
                                    )
                                );
                                dispatch(job.success({}));
                            },
                            onError() {
                                dispatch(job.error({}));
                            },
                            finally() {
                                dispatch(job.idle({}));
                            },
                        },
                    })
                );
                break;
            }
            default: {
                next(action);
                break;
            }
        }
    };
export default orb4HistoryMiddleware;
